// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"5d6fb5c0","347":"432458b4","453":"8f4fa8dd","455":"26f27fb7","525":"883504b7","746":"b58056e4","820":"11a48ea6"}[chunkId] + ".chunk.js";
};